module.exports = __webpack_public_path__ + "img/placeList2.27241bb6.png";